export enum SettingsFormType {
  advancedCheckbox = 'advancedCheckbox',
  avatar = 'avatar',
  checkbox = 'checkbox',
  chips = 'chips',
  input = 'input',
  number = 'number',
  select = 'select',
  toggle = 'toggle',
}

export interface FormGroupTemplate extends BaseFormGroupTemplate {
  forms?: FormControlTemplate[];
}

export interface FormSettingTemplate extends BaseFormGroupTemplate {
  formInformation: FormControlTemplate;
}

interface BaseFormGroupTemplate {
  actions?: {
    color?: string;
    href?: string;
    raised?: boolean;
    text?: string;
    disable?: boolean;
    callback?(forms?: any): void;
  }[];
  containerClass?: string;
  description?: string;
  disableActionBar?: boolean;
  disableForms?: boolean;
  disableFormsText?: string;
  headerAction?: {
    color?: string;
    icon?: string;
    model?: any;
    name?: string;
    text?: string;
    type?: string;
    updateKey?: string;
    callback?(updatedFormModel?: any): void;
  };
  title?: {
    primaryIcon?: string;
    secondaryIcon?: string;
    text?: string;
  };
  type?: string;
  validators?: any[];

  formsCallback?(formGroupValue: any): void;
}

export interface FormControlTemplate {
  data?: {
    disable?: boolean;
    documentType?: string;
    inputType?: string;
    label?: string;
    limit?: number;
    max?: number;
    min?: number;
    suffix?: string;
    options?: {
      text?: any;
      value?: any;
    }[];
    placeholder?: string;
  };
  disable?: boolean;
  formGroup?: FormControlTemplate[];
  hide?: boolean;
  model?: any;
  subForms?: FormControlTemplate[];
  type?: SettingsFormType;
  label?: string;
  showLabel?: boolean;
  subLabel?: string;
  updateKey?: string;
  validators?: any[];

  callback?(form: any): void;
}
